import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { rem, themed, media } from '@/shared/ui/core';

const modifiers = {
  info: ({ theme }) => ({
    styles: `
      color: ${theme.primary.text};
      font-weight: 400;
      font-size: 0.6875rem;
      line-height: 0.875rem;
      letter-spacing: 0.0156rem;
      text-transform: uppercase;
    `,
  }),
  bidGuidance: ({ theme }) => ({
    styles: `
      display: flex;
      flex-direction: column;
      font-size: 0.8125rem;
      font-weight: 500;
      letter-spacing: 0.0156rem;
      line-height: 0.875rem;
      margin: auto 0 0;

      span {
        color: ${theme.tabs.inactive};
        font-weight: 400;
        font-size: 0.6875rem;
        line-height: 0.8125rem;
        letter-spacing: 0.0156rem;
        margin-top: 0.175rem;
      }

      @media ${media.tabletMin} {
        margin: auto 0;
      }
    `,
  }),
  isFullService: ({ theme }) => ({
    styles: `
      span > span {
        color: ${theme.status.success};
      }
    `,
  }),
};

export const ShiftPriceWrapper = styled.div.attrs({
  className: 'ShiftPriceWrapper',
})`
  display: flex;
  flex-direction: ${({ dynamicType }) => (dynamicType ? 'row' : 'column')};
  justify-content: space-between;
  width: 100%;

  ${({ buyItNowType }) => buyItNowType
    && css`
      width: unset;

      & .ShiftPriceInput {
        margin-top: 0rem;

        @media ${media.tabletMin} {
          margin-top: 0.5rem;
        }
      }
    `}
`;

export const RecommendedLabel = styled.p.attrs({
  className: 'Label',
})`
  align-self: flex-start;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 0.875rem;
  letter-spacing: 0.015rem;
  margin: 0 0 0.25rem;
  max-width: 16.5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${applyStyleModifiers(modifiers)}
`;

export const ShiftPriceInput = styled.div.attrs({
  className: 'ShiftPriceInput',
})`
  align-items: center;
  display: flex;
  margin-left: auto;
  position: relative;

  & + .Text {
    color: ${themed('primary.textGray')};
    display: block;
    font-size: 0.675rem;
    letter-spacing: 0;
    margin-left: auto;
    margin-top: 0.5rem;
    max-width: 7.125rem;
    white-space: break-spaces;
  }
`;

export const ShiftPrice = styled.div.attrs({
  className: 'ShiftPrice',
})`
  min-width: 5.75rem;
  max-width: 7.125rem;
  flex-shrink: 0;
  position: relative;

  input.InputStyled {
    font-size: 1rem;
    text-align: right;
    padding: 0.5rem;
    padding-left: 1.5rem;
    margin: 0;
    appearance: none;

    -moz-appearance: textfield;
  }

  span {
    font-size: ${rem(18)};
    font-weight: 700;
    color: ${themed('primary.accent')};
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translate(-50%, -50%);
  }
`;

export const Delete = styled.div.attrs({
  className: 'Delete',
  role: 'button',
})`
  width: 2.5rem;
  height: 2.5rem;
  background-color: ${themed('primary.text')};
  border-radius: 0.25rem;
  margin-left: 0.5rem;
  display: block;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;

  svg {
    width: 1rem;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
